<template>
  <VoteBase>
    <template v-slot:voteMain>
      <div class="animated fadeIn">
        <b-card>
          <div slot="header">
            <b-button :to="{name: 'vote-list', params: {oversea: !!JSON.parse($route.query.oversea)}}" size="sm" variant="link"><i class="fa fa-chevron-left" /></b-button>
            用户奖励历史{{ !!JSON.parse($route.query.oversea) ? overseaTag : '' }}
          </div>
          <b-form inline style="margin-bottom: 10px;">
            <label class="mb-2 mr-sm-2 mb-sm-0">实例</label>
            <ModelSelect
              id="app-name"
              class="mb-2 mr-sm-2 mb-sm-0"
              :options="appOptions"
              v-model="selectedApp"
              required
              style="width: 20%;"
              placeholder="下拉选择实例"
            />
            <label class="mb-2 mr-sm-2 mb-sm-0">用户</label>
            <ModelSelect
              id="user"
              class="mb-2 mr-sm-2 mb-sm-0"
              :options="userOptions"
              v-model="userInfo"
              required
              style="width: 60%;"
              :placeholder="userPlaceholder"
            />
          </b-form>
          <b-table show-empty responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :emptyText="tableEmptyText" >
            <template #cell(index)="data">
              {{ data.index + 1 }}
            </template>
          </b-table>
          <nav v-if="items.length > 0">
            <b-pagination
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="<<"
              next-text=">>"
              @change="changePage"
              hide-goto-end-buttons
              first-number
              last-number
            />
          </nav>
        </b-card>
      </div>
    </template>
  </VoteBase>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import consts from '@/utils/consts'
import VoteBase from './Base'
import { ModelSelect } from 'vue-search-select'

export default {
  name: 'vote-reward-history',
  mixins: [Error],
  components: {VoteBase, ModelSelect},
  data () {
    return {
      appOptions: [],
      userOptions: [],
      selectedApp: '',
      userInfo: '',
      currentPage: 1,
      perPage: 0,
      items: [],
      totalRows: null,
      fields: consts.VOTE_USER_REWARD_FIELDS,
      separate: '__ZsFgf__',
      userLoginTypes: consts.VOTE_USER_LOGIN_TYPES,
      appDict: {},
      userPlaceholder: '',
      tableEmptyText: consts.TABLE_EMPTY_TEXT,
      overseaTag: consts.overseaTag
    }
  },
  created () {
    let params = {
      'where': '',
      'order': 'app_id'
    }
    this.$ajax.get(api.getAdminLoginInfo()).then((data) => {
      this.$store.dispatch('setUser', data.admin_info)
      params.where = JSON.stringify({'admin_urs': data.admin_info.email})
      this.getAppOptions(params)
    }, (res) => {
      this.$store.dispatch('setUser', null)
    })
  },
  watch: {
    selectedApp (val) {
      if (val) {
        this.userInfo = ''
        this.getUserOptions({app_id: val})
      }
    },
    userInfo (val) {
      if (val) {
        this.query()
      } else {
        this.items = []
        this.totalRows = null
      }
    }
  },
  methods: {
    getAppOptions (params) {
      api.fetchVoteListData(this, api.getVoteList(), 'follow_vote', params, JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : '', this.handleAppOptions)
    },
    handleAppOptions (resData) {
      let appOptions = []
      for (let idx in resData['follow_vote']) {
        appOptions.push({
          value: resData['follow_vote'][idx].app_id,
          text: resData['follow_vote'][idx].app_name
        })
        this.appDict[resData['follow_vote'][idx].app_id] = resData['follow_vote'][idx].app_name
      }
      this.appOptions = appOptions
    },
    getUserOptions (params) {
      api.fetchVoteListData(this, api.getRewardUserList(), 'user_list', params, JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : '', this.handleUserOptions)
    },
    handleUserOptions (resData) {
      let userOptions = []
      for (let idx in resData['user_list']) {
        userOptions.push({
          value: resData['user_list'][idx].user_name + this.separate + resData['user_list'][idx].login_typ,
          text: resData['user_list'][idx].user_name + '(' + this.userLoginTypes[resData['user_list'][idx].login_typ] + ')'
        })
      }
      if (userOptions.length) {
        this.userPlaceholder = '下拉选择用户'
      } else {
        this.userPlaceholder = '暂无用户可选'
      }
      this.userOptions = userOptions
    },
    query () {
      if (!this.selectedApp) {
        this.$message.error('未选择实例')
        return false
      }
      if (!this.userInfo) {
        this.$message.error('未选择用户')
        return false
      }
      this.getData()
    },
    getData () {
      let params = {
        app_id: this.selectedApp,
        user_name: this.userInfo.split(this.separate)[0],
        login_typ: this.userInfo.split(this.separate)[1],
        page: this.currentPage,
        limit: this.perPage
      }
      api.fetchVoteListData(this, api.getVoteUserReward(), 'reward_list', params, JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : '', this.getDataCallback)
    },
    getDataCallback (resData) {
      this.items = resData.reward_list
      this.totalRows = resData.total_num
      if (this.items.length === 0) {
        this.$message.info('查无数据')
      }
    },
    changePage (page) {
      this.currentPage = page
      this.getData()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// VoteRewardHistory.vue?8c47dcc4